import { Button } from '@dtx-company/design-system/src'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { useRouter } from 'next/router'
import Link from 'next/link'
import React from 'react'
import styled from 'styled-components'

const StyledContent = styled.div`
  margin-top: 100px;
  @media (min-width: 800px) {
    margin-top: 60px;
  }
`
const StyledBanner = styled.img`
  text-align: center;
  display: block;
  margin: 0 auto;
  height: 160px;
  @media (min-width: 374px) {
    height: 200px;
  }
  @media (min-width: 800px) {
    height: 280px;
  }
`
const StyledTitle = styled.p`
  height: 18px;
  text-align: center;
  font-size: 22px;
  font-weight: bold;
`
const StyledText = styled.p`
  height: 18px;
  text-align: center;
  font-size: 20px;
`

const StyledButton = styled(Button)`
  display: block;
  width: 200px;
  height: 48px;
  margin: 40px auto 0;
  font-weight: bold;
`

interface NotFoundProps {
  fromFlowpage?: boolean
  displayName?: string
  profileImage?: string
}

const Custom404: React.FC<NotFoundProps> = ({ fromFlowpage }: NotFoundProps): JSX.Element => {
  const router = useRouter()
  return (
    <>
      <StyledContent>
        <StyledBanner src="/static/404-cloud.svg" alt="404 banner"></StyledBanner>
        {fromFlowpage ? (
          <>
            <StyledText>{"Nobody's reserved this Flowpage yet."}</StyledText>
            <Link
              href={{
                pathname: Routes.PAGE,
                query: { slug: router?.query?.slug }
              }}
              legacyBehavior
              passHref
            >
              <StyledButton>Claim it Now</StyledButton>
            </Link>
          </>
        ) : (
          <>
            <StyledTitle>Oops!</StyledTitle>
            <StyledText>{"We can't seem to find that page."}</StyledText>
          </>
        )}
      </StyledContent>
    </>
  )
}

export default Custom404
